module.exports = __webpack_public_path__ + "img/爱心.d3d5cbca.gif";